module.exports = __webpack_public_path__ + "media/images/badges/Apple_icon-c8d895335c63617b7ec69554fb291b5a.svg";